export enum ReportFileType {
  AgencySalesReport = 'agencySalesReport',
  AgencyCommissionsReport = 'agencyCommissionsReport',
  Unidentified = 'unidentified',
}
